import React from 'react'
import { Breadcrumb as AntBreadcrumb } from 'antd'
import { useHistory } from 'react-router-dom'
import { BreadcrumbContext } from './context'
import styles from './Breadcrumb.module.less'

function Breadcrumb(props) {
  const history = useHistory()
  const { inserRoute } = props

  return (
    <BreadcrumbContext.Consumer>
      {(routes: any[] = []) => {
        if (inserRoute && Array.isArray(routes)) {
          const { pos } = inserRoute
          if (routes.every((item) => !item.route.pos)) {
            routes.splice(pos, 0, { route: inserRoute })
          }
        }
        return (
          <AntBreadcrumb className={styles.container}>
            {routes.map(({ route }, index) => {
              const isFirst = index === 0
              const isLast = index === routes?.length - 1

              if (isFirst) {
                return (
                  <AntBreadcrumb.Item onClick={() => history.push(route.path)} key={index}>
                    <span className={styles.breadcrumbItem}>{/* <Icon type="home" /> */}</span>
                  </AntBreadcrumb.Item>
                )
              }

              if (isLast) {
                return (
                  <AntBreadcrumb.Item key={index}>
                    <span>{route.menuTitle}</span>
                  </AntBreadcrumb.Item>
                )
              }

              return (
                <AntBreadcrumb.Item onClick={() => history.push(route.path)} key={index}>
                  <span className={styles.breadcrumbItem}>{route.menuTitle}</span>
                </AntBreadcrumb.Item>
              )
            })}
          </AntBreadcrumb>
        )
      }}
    </BreadcrumbContext.Consumer>
  )
}

export default React.memo(Breadcrumb)
